export enum SubMenuType {
  NONE,
  CHAT,
  GUESTS,
  ROOM_SETTINGS,
  PRESENTATION_SETTINGS,
  AUDIO_SETTINGS,
  MANAGE_PRESENTERS,
  FILE_LIBRARY,
}

export interface SubMenu {
  title: string;
  type: SubMenuType;
}

// Secondary Menus
export const CHAT_SUB_MENU: SubMenu = {
  title: 'Chat',
  type: SubMenuType.CHAT,
};

export const GUESTS_SUB_MENU: SubMenu = {
  title: 'Guests',
  type: SubMenuType.GUESTS,
};

export const ROOM_SETTINGS_SUB_MENU: SubMenu = {
  title: 'Room Settings',
  type: SubMenuType.ROOM_SETTINGS,
};

export const PRESENTATION_SETTINGS_SUB_MENU: SubMenu = {
  title: 'Presentation Settings',
  type: SubMenuType.PRESENTATION_SETTINGS,
};

export const FILE_LIBRARY_SUB_MENU: SubMenu = {
  title: 'Files',
  type: SubMenuType.FILE_LIBRARY,
};

// Tertiary Menus
export const AUDIO_SETTINGS_SUB_MENU: SubMenu = {
  title: 'Audience Settings',
  type: SubMenuType.AUDIO_SETTINGS,
};

export const MANAGE_PRESENTERS_SUB_MENU: SubMenu = {
  title: 'Manage Presenters',
  type: SubMenuType.MANAGE_PRESENTERS,
};
